import { useContext, useState } from 'react'
import { useNavigate } from 'react-router'
import { MoreVert } from '@mui/icons-material'
import { IconButton, Menu, MenuItem, useTheme } from '@mui/material'

import ExternalLinkMenuItem from '../../../../components/external-link-menu-item'
import { AppContext } from '../../../../providers/app-provider'
import { useAuthentication } from '../../../../providers/auth-provider'
import { PROTECT_LITE_URL } from '../../../../utils/constants'

import useStyles from './index.styles'

interface IProps {
  setShowEditUserModal: (value: boolean) => void
  user: IUserType
  setShowImpersonateDialog: (value: boolean) => void
}

const MoreOptionsMenu = (props: IProps) => {
  const { setShowEditUserModal, user, setShowImpersonateDialog } = props

  const { hasInternalUserAccess } = useAuthentication()
  const { tenantId } = useContext(AppContext)

  const classes = useStyles
  const theme = useTheme()
  const navigate = useNavigate()
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null)
  const menuOpen = Boolean(menuAnchor)

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchor(event.currentTarget)
  }

  const handleMenuClose = () => {
    setMenuAnchor(null)
  }

  const handleEditClick = () => {
    handleMenuClose()
    setShowEditUserModal(true)
  }

  const handleImpersonateInMobileClick = () => {
    setShowImpersonateDialog(true)
    handleMenuClose()
  }

  return (
    <>
      <IconButton
        size="small"
        onClick={handleMenuOpen}
        aria-label="Toggle quick actions menu"
        sx={{ ...(menuOpen ? classes.moreOptionsBtnSelected(theme) : {}) }}
      >
        <MoreVert />
      </IconButton>

      <Menu
        anchorEl={menuAnchor}
        id="quick-actions-menu"
        open={menuOpen}
        onClose={handleMenuClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {hasInternalUserAccess && <MenuItem onClick={handleEditClick}>Quick Edit</MenuItem>}

        <MenuItem onClick={() => navigate(`/tenant/${tenantId}/people/${user.id}`)}>View Profile</MenuItem>

        {hasInternalUserAccess && (
          <MenuItem sx={classes.menuItemWithIcon} onClick={handleImpersonateInMobileClick}>
            Impersonate in Mobile
          </MenuItem>
        )}

        {hasInternalUserAccess && <ExternalLinkMenuItem href={`${PROTECT_LITE_URL}?userToImpersonate=${user.id}`} label="Impersonate in Lite" />}

        {/* TODO uncomment this when Impersonate in Insights is fixed and working */}
        {/* {hasInternalUserAccess && <ExternalLinkMenuItem href={`${INSIGHTS_URL}?userToImpersonate=${user.id}`} label="Impersonate in Insights" />} */}
      </Menu>
    </>
  )
}

export default MoreOptionsMenu
